// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteProfileModal_wrapper__oBpxB","text":"DeleteProfileModal_text__4Rzc4","actions":"DeleteProfileModal_actions__9hgQz"};